export default "__VITE_ASSET__2Gus0j6H__";